export const rankingItems = [
  { id: 1, rank: 1, title: '某顶流深夜现身三里屯，身旁神秘女子引猜测', heat: '128,462', tag: 'hot' },
  { id: 2, rank: 2, title: '周深2026巡回演唱会首站3分钟售罄', heat: '115,230', tag: 'hot' },
  { id: 3, rank: 3, title: '《长相思》第二季首播豆瓣开分8.9', heat: '98,475', tag: 'new' },
  { id: 4, rank: 4, title: '《长安十二时辰》电影版官宣开机，原班人马回归', heat: '86,312', tag: '' },
  { id: 5, rank: 5, title: '年度音乐盛典幕后故事全记录', heat: '73,189', tag: '' },
  { id: 6, rank: 6, title: '金鸡奖提名名单公布，新生代占比超六成', heat: '61,024', tag: '' },
  { id: 7, rank: 7, title: '新晋影后独家专访：十二年从龙套到影后', heat: '52,887', tag: '' },
];